/**
 *
 * @module entry
 * @desc {SDK.Services.Util} entry point.
 *
 */

import checkResponseCode from './checkResponseCode';
import getSafe from './getSafe';
import getScope from './getScope';
import adEngineRegex from './adEngineRegex';
import dateRegex from './dateRegex';

/**
 *
 * @typedef SDK.Services.Util
 * @type {Object}
 *
 * @property {Function} checkResponseCode
 * @property {Function} getSafe
 * @property {Function} getScope
 * @property {Function} adEngineRegex
 *
 */

/**
 *
 * @type {SDK.Services.Util}
 *
 */
export default {

    checkResponseCode,
    getSafe,
    getScope,
    adEngineRegex,
    dateRegex

};



// WEBPACK FOOTER //
// ./src/services/util/entry.js